import { Button } from '@wishket/design-system';
import Link, { LinkProps } from 'next/link';

interface LinkButtonProps extends LinkProps {
  isSignUp?: boolean;
  name: string;
  isNewWindow?: boolean;
}

export const LinkButton = ({
  href,
  name,
  isSignUp,
  isNewWindow,
}: LinkButtonProps) => {
  return (
    <Link href={href} target={isNewWindow ? '_blank' : '_self'}>
      {isSignUp ? (
        <Button variant="solid" size="sm" className="w-[82px]">
          {name}
        </Button>
      ) : (
        <Button
          variant="outlined"
          size="sm"
          className="w-20 border-none bg-transparent text-w-gray-900 hover:bg-w-gray-50"
        >
          {name}
        </Button>
      )}
    </Link>
  );
};

export const MobileLinkButton = ({
  href,
  name,
  isNewWindow,
}: LinkButtonProps) => {
  return (
    <Link
      href={href}
      target={isNewWindow ? '_blank' : '_self'}
      className="desktop:hidden"
    >
      <Button
        variant="outlined"
        size="sm"
        className="rounded-full bg-transparent text-w-gray-600 hover:border-w-gray-200 hover:bg-w-gray-50"
      >
        {name}
      </Button>
    </Link>
  );
};
